import React from "react";
import {
  FormControl,
  FormHelperText,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import { useTranslation } from "react-i18next";

export const CustomTextField = ({
  label,
  unit,
  error,
  value,
  handleChange,
  disabled = false,
  type = "number",
  required = false,
  placeholder = "",
  min = 0,
}) => {
  const { t } = useTranslation("ActivityMain");

  return (
    <FormControl fullWidth sx={{ my: 1, minWidth: 80 }} error={error}>
      <Typography sx={{ marginBottom: 1 }}>
        {required && <span style={{ color: "red" }}>*</span>} {label}
      </Typography>
      <TextField
        type={type}
        value={value}
        onChange={handleChange}
        required={required}
        disabled={disabled}
        fullWidth
        placeholder={t(placeholder)}
        InputProps={{
          endAdornment: unit ? (
            <InputAdornment position="end">{t(unit)}</InputAdornment>
          ) : null,
        }}
        InputLabelProps={{
          shrink: false,
        }}
        inputProps={{
          min: min,
        }}
        onKeyDown={(e) => {
          // 修改這裡：只有當 type 是 "number" 的時候，才去阻擋 "-" 和 "e"
          if (type === "number" && (e.key === "-" || e.key === "e")) {
            e.preventDefault();
          }
        }}
      />
      <FormHelperText
        sx={{
          minHeight: "20px",
          marginTop: "3px",
          visibility: error ? "visible" : "hidden",
        }}
      >
        {t("Please enter value")}
      </FormHelperText>
    </FormControl>
  );
};
